import React, { useState } from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "../ui/Button";
import ReportProfessionalModal from "./ReportProfessionalModal";
import { useTranslation } from "react-i18next";

interface ReportProfessionalButtonProps {
  professional: any;
  contractId?: string;
  jobId?: string;
  variant?: "default" | "outline" | "ghost";
  size?: "sm" | "lg";
  className?: string;
}

const ReportProfessionalButton: React.FC<ReportProfessionalButtonProps> = ({ 
  professional, 
  contractId,
  jobId,
  variant = "outline",
  size = "sm",
  className = ""
}) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  
  return (
    <>
      <Button
        variant={variant}
        size={size}
        onClick={() => setShowModal(true)}
        className={`text-red-600 border-red-300 hover:bg-red-50 ${className}`}
      >
        <AlertTriangle className="h-4 w-4 mr-2" />
        {t("reportProfessionalButton.reportIssue")}
      </Button>
      
      {showModal && (
        <ReportProfessionalModal
          professional={professional}
          contractId={contractId}
          jobId={jobId}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default ReportProfessionalButton;

